import { init } from '@plausible-analytics/tracker'
init({
  domain: window.location.hostname,
  endpoint: '/qua5aish/kixa9lal'
})
